var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 48 48",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0055 11.6567C46.6868 11.3354 46.3076 11.0803 45.8898 10.9063C45.472 10.7322 45.0238 10.6426 44.5712 10.6426C44.1186 10.6426 43.6705 10.7322 43.2527 10.9063C42.8349 11.0803 42.4557 11.3354 42.1369 11.6567L24.6169 29.1767C24.537 29.2597 24.4411 29.3257 24.3351 29.3708C24.229 29.4158 24.115 29.4391 23.9998 29.4391C23.8846 29.4391 23.7705 29.4158 23.6645 29.3708C23.5585 29.3257 23.4626 29.2597 23.3826 29.1767L5.86265 11.6567C5.54392 11.3354 5.16471 11.0803 4.74691 10.9063C4.3291 10.7322 3.88097 10.6426 3.42836 10.6426C2.97575 10.6426 2.52761 10.7322 2.10981 10.9063C1.69201 11.0803 1.3128 11.3354 0.994074 11.6567C0.355499 12.2991 -0.00292969 13.1681 -0.00292969 14.0739C-0.00292969 14.9797 0.355499 15.8486 0.994074 16.491L20.3655 35.8625C21.3298 36.8255 22.6369 37.3665 23.9998 37.3665C25.3626 37.3665 26.6698 36.8255 27.6341 35.8625L47.0055 16.491C47.6441 15.8486 48.0025 14.9797 48.0025 14.0739C48.0025 13.1681 47.6441 12.2991 47.0055 11.6567Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.0ae85b633b4912bc77e14753e9d43403.svg";
export { ForwardRef as ReactComponent };